module.exports = __webpack_public_path__ + "static/media/ArrowDownBlack.50840e41.svg";